import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SettingsState {
  settings: any | null;
}

const initialState: SettingsState = {
  settings: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<any>) => {
      state.settings = action.payload;
    },
  },
});

export const { setSettings } = settingsSlice.actions;
export default settingsSlice.reducer;